<template>
    <div class="hekang">
        <div style="text-align: center">
            <!-- <img src="../assets/img/hk-title.png" alt=""> -->
        </div>
        <div
            style="
                text-align: center;
                height: calc(100% - 85px);
                padding: 30px 0;
                box-sizing: border-box;
            "
        >
            <!-- <img src="../assets/img/hk-localtion.png" alt="" style="height: 100%"> -->
        </div>

        <!--    <img src="@/assets/img/hekang.jpg" alt="">-->
        <!--    <div>-->
        <!--      <span style="font-family: 'ds-digit';font-size: 50px">123456789</span>-->
        <!--    </div>-->
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {},
}
</script>
<style lang="less" scoped>
.hekang {
    width: 100%;
    height: 100%;
    background: url("../assets/imgs/hk-bg.jpg");
    background-size: 100% 100%;
    // overflow: hidden;

    .hk-left {
        position: fixed;
        left: 10%;
        top: 100px;
        font-size: 30px;
        color: #fff;
        text-align: center;

        li {
            margin-top: 10vh;
        }

        p {
            font-family: "ds-digit";
            font-size: 50px;
            margin-top: 5px;
            color: #01b8e3;
        }
    }

    .hk-right {
        position: fixed;
        right: 3%;
        top: 100px;
        font-size: 1.1vw;
        color: #fff;

        li {
            // background: url("../assets/img/hk-block.png")no-repeat;
            background-size: 100% 100%;
            width: 24vw;
            height: 19vh;
            margin-top: 5%;

            div {
                text-align: center;
            }

            p {
                padding: 20px;
            }
        }
    }
}
</style>
